// extracted by mini-css-extract-plugin
export default {"message":"pFY9qXpaK_BQZDyWYnDr","validationMessage":"bWyfdVOnriyO26ZWC9pM","label":"K4xzeQYwF4eFfIUF7tKu","labelFront":"JtInaT3O7Ye5SjeJGZPf","root":"rOSRDT8gjl84L27Eq2jQ"};